q
<template>
    <v-row v-if="syncState === 'BUG'" no-gutters class="bg-light-red my-2 rounded">
        <v-col cols="6" class="rounded-right white px-2" style="position: relative">
            <v-img height="50px" width="50" contain src="/img/ameli.png" />
            <h5>Ameli</h5>
            <v-icon class="mr-2 text-muted" size="x-small">$fa-sync-alt</v-icon>
            <span class="text-muted" size="x-small">18 mars 2024 - 2:49</span>
            <v-btn-icon
                icon="$fa-gear"
                size="small"
                style="position: absolute; top: 5px; right: 5px"
            />
        </v-col>
        <v-col cols="6" class="px-2">
            <div>
                <v-icon class="mr-2 text-error" size="x-small">$fa-question-circle</v-icon>
                <span size="x-small" class="text-error">Bug</span>
            </div>
            <div size="x-small" class="text-error">
                La synchronisation de cette connexion rencontre des problèmes.
            </div>
        </v-col>
    </v-row>

    <v-row v-else-if="syncState === 'OK'" no-gutters class="bg-light-green my-2 rounded">
        <v-col cols="6" class="rounded-right white px-2" style="position: relative">
            <v-img height="50px" width="50" contain src="/img/magento.png" />
            <h5>Magento</h5>
            <v-icon class="mr-2 text-muted" size="x-small">$fa-sync-alt</v-icon>
            <span class="text-muted" size="x-small">18 mars 2024 - 2:49</span>
            <v-btn-icon
                icon="$fa-gear"
                size="small"
                style="position: absolute; top: 5px; right: 5px"
            />
        </v-col>
        <v-col cols="6" class="px-2">
            <div size="x-small" class="d-flex justify-content-center pt-3">
                La synchronisation de cette connexion rencontre des problèmes.
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class ConnectorStateCard extends Vue {
    @Prop({ default: null }) connector: any;
    @Prop({ default: "" }) syncState: string; // Etat de la synchornisqtion ex: OK, BUG

    beforeMount() {
        if (!this.connector) {
            this.connector = {};
        }
    }
}

export default toNative(ConnectorStateCard);
</script>
<style scoped>
.rounded-right {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
}

.bg-light-red {
    background-color: rgba(240, 128, 128, 0.4);
}

.bg-light-green {
    background-color: rgba(32, 168, 129, 0.664);
}

.text-error {
    color: red !important;
}

.text-muted {
    color: grey !important;
}
</style>
